module.exports = __webpack_public_path__ + "img/hook_PEWAG_LHW_2.64b9e634.png";